type FormDataObj = { [key: string]: string|FormDataObj };
type PostDataType = { [key: string]: string }|FormData;
type GetDataType = { [key: string]: string };

/**
 * Convert a FormData to an Object
 * 
 * @param {FormData} form 
 * 
 * @return {FormDataObj}
 */
export function formDataToObject(form: FormData) : FormDataObj {
    const obj: FormDataObj = {};

    form.forEach((value: any, key: string) => {
        if (value instanceof FormData) {
            value = formDataToObject(value);
        }

        obj[key] = value;
    });

    return obj;
}

/**
 * Do a POST request
 * 
 * @param {string} url
 * @param {DataType} data 
 * @param {AbortSignal|null} signal 
 * 
 * @return {Promise<any>}
 */
export async function postData(url: string, data: PostDataType = {}, signal: AbortSignal|null = null) : Promise<any> {
    let body = new FormData();

    if (data instanceof FormData) {
        body = data;
    } else {
        Object.keys(data).forEach(key => {
            body.append(key, data[key]);
        });
    }

    const args: RequestInit = {
        method: 'POST',
        credentials: 'same-origin',
        body,
    };

    if (signal) {
        args.signal = signal;
    }

    const response = fetch(url, args);
    return getAjaxResponse(response);
}

/**
 * Do a GET request
 * 
 * @param {string} url
 * @param {GetDataType} data 
 * @param {AbortSignal|null} signal 
 * 
 * @return {Promise<any>}
 */
export async function getData(url: string, data: GetDataType = {}, signal: AbortSignal|null = null) : Promise<any> {
    const urlParams = new URLSearchParams();

    Object.keys(data).forEach(key => {
        urlParams.append(key, data[key]);
    });

    const args: RequestInit = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
    };

    if (signal) {
        args.signal = signal;
    }

    if (Array.from(urlParams).length) {
        url += '?' + urlParams.toString();
    }

    const response = fetch(url, args);
    return getAjaxResponse(response);
}

/**
 * Return the ajax response
 * 
 * @param {Promise<any>} response
 * 
 * @return {Promise<any>}
 */
async function getAjaxResponse(response: Promise<any>) : Promise<any> {
    return await response
        .then(r => {
            const contentType = r.headers.get('content-type');
            const isJson = contentType && contentType.indexOf('application/json') !== -1;

            return isJson ? r.json() : r;
        })
        .then(r => {
            // Redirect to the login page
            // if the response contains the key "error_type" and is equal to "user_not_logged"
            if ('undefined' !== typeof r.data && 'undefined' !== typeof r.data.error_type && r.data.error_type === 'user_not_logged') {
                window.location.href = scriptVar.loginUrl + '?referrer=' + window.location.href;
                throw Error;
            }

            return r;
        });
}
